import { render, staticRenderFns } from "./ExchangeCode.vue?vue&type=template&id=17fbc16f&scoped=true"
import script from "./ExchangeCode.vue?vue&type=script&lang=js"
export * from "./ExchangeCode.vue?vue&type=script&lang=js"
import style0 from "./ExchangeCode.vue?vue&type=style&index=0&id=17fbc16f&prod&lang=scss&scoped=true"
import style1 from "./ExchangeCode.vue?vue&type=style&index=1&id=17fbc16f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fbc16f",
  null
  
)

export default component.exports